<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <list-page
        :columns="columns"
        :headers="headers"
        :popupComponent="popupComponent"
        :basic-data="basicData"
        title="Site Owners List"
        icon="mdi-minecraft"
        addButtonText="Site Owner"
        stateendpoint="siteOwner.siteOwners"
        :actions="actions"
    />
  </div>
</template>
<script>
import ListPage from "../components/ListPage";
import SiteOwnerPopup from "../components/popups/SiteOwnerPopup";

export default {
  name: 'SiteOwners',
  components: {
    ListPage,
    SiteOwnerPopup
  },
  metaInfo: {
    title: 'Exwebs',
    titleTemplate: 'Admin Dashboard - Site Owners | %s',
    meta: [
      { name: 'robots', content: 'noindex' },
      { name: 'googlebot', content: 'noindex' }
    ]
  },
  data() {
    return {
      headers: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Email',
          align: 'right',
          value: 'email'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          text: '', value: 'actions', sortable: false
        }
      ],
      columns: [
        {value: 'name'},
        {value: 'email'},
        {value: 'isActive'},
        {value: 'action'},
      ],
      actions: {
        load: 'loadSiteOwners',
        create: 'storeSiteOwner',
        update: 'updateSiteOwner',
        remove: 'removeSiteOwner',
        destroy: 'destroySiteOwner'
      },
      basicData: {
        isActive: true
      }
    }
  },
  computed: {
    popupComponent() {
      return SiteOwnerPopup;
    }
  }
}
</script>
